import { BACKEND_URL } from "@/lib/api";

function resolveUrl(src) {
  const s = (src || "").trim();
  if (!s) return "";
  if (s.startsWith("http://") || s.startsWith("https://") || s.startsWith("data:")) {
    return s;
  }
  // Relative API path (e.g. "/api/uploads/{id}") → prefix with backend
  return `${BACKEND_URL}${s.startsWith("/") ? s : `/${s}`}`;
}

export default function MediaGallery({ settings }) {
  const rawImgs = Array.isArray(settings?.gallery_images) ? settings.gallery_images : [];
  const rawAlts = Array.isArray(settings?.gallery_alts) ? settings.gallery_alts : [];

  const items = rawImgs
    .map((src, idx) => ({
      src: resolveUrl(src),
      alt: (rawAlts[idx] || "").trim() || `MediaFly Production – Projekt ${idx + 1}`,
    }))
    .filter((it) => Boolean(it.src));

  if (items.length === 0) {
    // Keep page lean if admin hasn't configured any gallery image yet
    return null;
  }

  return (
    <section
      className="border-b border-white/10 bg-mfp-bg"
      data-testid="gallery-section"
      id="aktuelle-projekte"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-14 md:py-24">
        <div className="mb-8 md:mb-12">
          <div className="text-[11px] uppercase tracking-[0.3em] text-mfp-gold font-bold mb-3">
            Portfolio
          </div>
          <h2 className="font-display text-3xl md:text-5xl uppercase leading-[1.05]">
            Aktuelle <span className="text-mfp-gold">Projekte</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
          {items.map((it, idx) => (
            <div
              key={`${it.src}-${idx}`}
              className="group relative overflow-hidden rounded-xl border border-white/10 bg-mfp-surface aspect-[4/5]"
              data-testid={`gallery-item-${idx}`}
            >
              <img
                src={it.src}
                alt={it.alt}
                loading="lazy"
                width="800"
                height="1000"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                onError={(e) => {
                  e.currentTarget.style.opacity = "0";
                }}
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/55 via-black/0 to-black/0 opacity-80 group-hover:opacity-95 transition-opacity" />
              <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-mfp-gold/0 group-hover:ring-mfp-gold/40 transition-all" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
